import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import {
  createTax,
  createWarehouse,
  getListCountry,
  updateTax,
  updateWarehouse,
} from "../../services/MoloniServices";
import { Tabs, Tab } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ConfigDB from "../../config";

const AddWarehouseMoloni = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [wareHouseData, setWarehouseData] = useState({
    id: "",
    title: "",
    is_default: 0,
    code: "",
    address: "",
    city: "",
    zip_code: "",
    country_id: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
    business_name: "",
    email: "",
    address: "",
    city: "",
    zip_code: "",
    phone: "",
    fax: "",
    website: "",
    notes: "",
    documents_footnote: "",
    email_sender_name: "",
    email_sender_address: "",
    country_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [currentStep, setCurrentStep] = useState("step1");
  const [timeZoneList, setTimeZoneList] = useState([]);

  useEffect(() => {
    if (state) {
      setWarehouseData({
        id: state?.id,
        title: state?.title,
        is_default: state?.is_default,
        code: state?.code,
        address: state?.address,
        city: state?.city,
        zip_code: state?.zip_code,
        phone: state?.phone,
        fax: state?.fax,
        contact_name: state?.contact_name,
        contact_email: state?.contact_email,
        country_id: state?.country_id,
        moloni_id: state?.moloni_id,
        notes: state?.notes,
      });
    }
  }, [state]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!wareHouseData.title) {
      errorObj.title = `Title is required.`;
      error = true;
    }

    if (!wareHouseData.code) {
      errorObj.code = `Code is required.`;
      error = true;
    }

    if (!wareHouseData.address) {
      errorObj.address = `Address is required.`;
      error = true;
    }

    if (!wareHouseData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!wareHouseData.zip_code) {
      errorObj.zip_code = `Zip code is required.`;
      error = true;
    }

    if (!wareHouseData.country_id) {
      errorObj.country_id = `Country is required.`;
      error = true;
    }

    if (wareHouseData.contact_email) {
      const isValidGmail = /^[a-zA-Z0-9._%+-]+@gmail\.com$/.test(
        wareHouseData.contact_email,
      );
      if (!isValidGmail) {
        errorObj.contact_email =
          "Email must be a valid Gmail address (e.g., name@gmail.com)";
        error = true;
      }
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      title: wareHouseData?.title,
      code: wareHouseData?.code,
      address: wareHouseData?.address,
      city: wareHouseData?.city,
      zip_code: wareHouseData?.zip_code,
      phone: wareHouseData?.phone,
      fax: wareHouseData?.fax,
      contact_name: wareHouseData?.contact_name,
      contact_email: wareHouseData?.contact_email,
      country_id: wareHouseData?.country_id,
      is_default: wareHouseData?.is_default,
    };

    let updateData = {
      company_id: "269134",
      id: wareHouseData?.id,
      title: wareHouseData?.title,
      code: wareHouseData?.code,
      address: wareHouseData?.address,
      city: wareHouseData?.city,
      zip_code: wareHouseData?.zip_code,
      phone: wareHouseData?.phone,
      fax: wareHouseData?.fax,
      contact_name: wareHouseData?.contact_name,
      contact_email: wareHouseData?.contact_email,
      country_id: wareHouseData?.country_id,
      is_default: wareHouseData?.is_default,
      warehouse_id: wareHouseData?.moloni_id,
    };

    if (wareHouseData?.id) {
      updateWarehouse(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/warehouses");
          setIsModifyButtonLoad(false);
          setWarehouseData({
            id: "",
            title: "",
            is_default: 0,
            code: "",
            address: "",
            city: "",
            zip_code: "",
            country_id: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createWarehouse(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/warehouses");
          setIsModifyButtonLoad(false);
          setWarehouseData({
            id: "",
            title: "",
            is_default: 0,
            code: "",
            address: "",
            city: "",
            zip_code: "",
            country_id: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  const handleCheckboxDefaultChange = (e) => {
    setWarehouseData({
      ...wareHouseData,
      is_default: e.target.checked ? 1 : 0,
    });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center"></div>

              <div className="col-sm-6 text-end">
                <h1 className="page-title">{"Warehouses"}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmitForm}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <Tabs
                          activeKey={currentStep}
                          onSelect={(k) => setCurrentStep(k)}
                          className="mb-3"
                          style={{
                            marginTop: "-11px",
                            marginLeft: "-3px",
                            width: "137px",
                            borderRadius: "0px",
                          }}
                        >
                          <Tab eventKey="step1" title="Main">
                            <div className="row">
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("title")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={wareHouseData.title}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            title: e.target.value,
                                          });
                                        }}
                                        name={`title`}
                                        maxLength={50}
                                        placeholder="title"
                                      />
                                    </div>
                                    {errors.title && (
                                      <span className="input-error">
                                        {errors.title}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("code")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={wareHouseData.code}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            code: e.target.value,
                                          });
                                        }}
                                        name={`code`}
                                        maxLength={50}
                                        placeholder="Code"
                                      />
                                    </div>
                                    {errors.code && (
                                      <span className="input-error">
                                        {errors.code}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("address")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={wareHouseData.address}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            address: e.target.value,
                                          });
                                        }}
                                        name={`address`}
                                        maxLength={50}
                                        placeholder="Address"
                                      />
                                    </div>
                                    {errors.address && (
                                      <span className="input-error">
                                        {errors.address}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("city")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={wareHouseData.city}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            city: e.target.value,
                                          });
                                        }}
                                        name={`city`}
                                        maxLength={50}
                                        placeholder="City"
                                      />
                                    </div>
                                    {errors.city && (
                                      <span className="input-error">
                                        {errors.city}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("zip_code")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={wareHouseData.zip_code}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            zip_code: e.target.value,
                                          });
                                        }}
                                        name={`zip_code`}
                                        maxLength={50}
                                        placeholder="Zip code"
                                      />
                                    </div>
                                    {errors.zip_code && (
                                      <span className="input-error">
                                        {errors.zip_code}
                                      </span>
                                    )}
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("phone")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={wareHouseData.phone}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            phone: e.target.value,
                                          });
                                        }}
                                        name={`phone`}
                                        placeholder="Phone"
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("fax")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={wareHouseData.fax}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            fax: e.target.value,
                                          });
                                        }}
                                        name={`fax`}
                                        placeholder="Fax"
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("contact_name")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={wareHouseData.contact_name}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            contact_name: e.target.value,
                                          });
                                        }}
                                        name={`contact_name`}
                                        maxLength={50}
                                        placeholder="Contact name"
                                      />
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("contact_email")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={wareHouseData.contact_email}
                                        onChange={(e) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            contact_email: e.target.value,
                                          });
                                        }}
                                        name={`contact_email`}
                                        maxLength={50}
                                        placeholder="Contact email"
                                      />
                                      {errors.contact_email && (
                                        <span className="input-error">
                                          {errors.contact_email}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my">
                                    {t("country")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <Select
                                        className="my-select-v"
                                        options={timeZoneList}
                                        value={timeZoneList.find(
                                          (item) =>
                                            item.value ==
                                            wareHouseData.country_id,
                                        )}
                                        onChange={(selectedOption) => {
                                          setWarehouseData({
                                            ...wareHouseData,
                                            country_id: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Country"}
                                      />
                                      {errors.country_id && (
                                        <span className="input-error">
                                          {errors.country_id}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>

                              <div className="col-md-3">
                                <FormGroup>
                                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                                    {t("is_default")}
                                  </Label>
                                  <div className="col-xl-12">
                                    <div className="input-div">
                                      <div className="form-check">
                                        <input
                                          className="my-checkbox-1 form-check-input"
                                          type="checkbox"
                                          checked={
                                            wareHouseData.is_default === 1
                                          }
                                          onChange={handleCheckboxDefaultChange}
                                        />
                                        <label className="form-check-label pl-6">
                                          {t("is_default")}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-3"></div>
                              <div className="col-md-3"></div>
                            </div>
                          </Tab>
                        </Tabs>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col ms-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate("/warehouses")}
                      >
                        <i className="bi bi-arrow-left"> </i> {t("back")}
                      </button>
                    </div>
                    <div className="col">
                      <div className="d-flex justify-content-end nxt-btn">
                        {isModifyButtonLoad === true ? (
                          <button type="submit" className="btn btn-primary">
                            Loading...
                          </button>
                        ) : (
                          <button type="submit" className="btn btn-primary">
                            {t("submit")} <i className="bi bi-check2"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddWarehouseMoloni;
